import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import PainelMonitoramento from "../components/PainelMonitoramento";

const AppRoutes: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/monitoramento/painel-servicos-monitorados" element={<PainelMonitoramento />} />
      <Route path="/monitoramento" element={<Navigate to="/monitoramento/painel-servicos-monitorados" />} />
    </Routes>
  </Router>
);

export default AppRoutes;
